// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__qBu8e","clinicsSelect":"styles_clinicsSelect__3M4uC"};